// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__yfRMG","languages":"Header_languages__2FpNd","group":"Header_group__2Iaxc","title":"Header_title__1TBhE"};